<template>
  <div class="w-full">
    <table class="rounded-lg shadow-lg w-full">
      <thead class="bg-gray-200 ">
      <tr>
        <th scope="col">#</th>
        <th scope="col">Name of Programme</th>
        <th>Intake</th>
        <th>Choice Code</th>
      </tr>
      </thead>
      <tbody>
      <tr class="bg-white border-b hover:bg-gray-100" v-for="(programme,index) in programmes" :key="index">
        <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">{{index+1}}</td>
        <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">{{programme.name}}</td>
        <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">{{ programme.intake }}</td>
        <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">{{programme.choiceCode}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "SanctionIntake",
  props: {
    programmes: Array,
  }
}
</script>

<style scoped>

</style>